export const cleanLinebreaks = (str) => str.replace(/(\r\n|\n|\r)/gm, '');
